/**
 * gsp-filters.js (optimized bundle)
 * - Show all / Show less toggle
 * - Search under title (ONLY for product_filter_metafield widgets)
 * - Hide empty metafield filter widgets
 * - Safe with AJAX rerenders (MutationObserver)
 * - Adds html.gsp-filters-ready to prevent initial jump with defer
 * - Hide Show more/less while typing in search
 * - Do NOT show search if options count <= limit (no Show more/less exists)
 * - Search matches by word prefix (supports multi-word queries like "sea sa" -> "Sea Salt")
 */
(function () {
  'use strict';

  var SIDEBAR_SEL = '#gsp-sidebar, #gsp-sidebar-mobile';
  var META_WIDGET_SEL = '.gsp-widget.gsp-widget-product_filter_metafield';
  var SHOWALL_SEL = '.gsp-filter-showall-link';
  var INPUT_CLASS = 'gsp-filter-search';
  var WRAP_CLASS = 'gsp-filter-search-wrap';

  var scheduled = false;
  var rowsCache = typeof WeakMap !== 'undefined' ? new WeakMap() : null;      // widget -> rows[]
  var textCache = typeof WeakMap !== 'undefined' ? new WeakMap() : null;      // row -> normalized text
  var hasBootstrapCollapse = !!(window.bootstrap && window.bootstrap.Collapse);

  function raf(fn) {
    return (window.requestAnimationFrame ? requestAnimationFrame(fn) : setTimeout(fn, 16));
  }

  function norm(s) {
    return (s || '').toLowerCase().trim();
  }

  function getSidebars() {
      return document.querySelectorAll(SIDEBAR_SEL);
  }

  // -------------------------
  // Show all / Show less
  // -------------------------
  function getShowAllKey(trigger) {
    var k = trigger.getAttribute('data-gsp-showall-key');
    if (k) return k;

    var tgt = trigger.getAttribute('data-bs-target');
    if (tgt && tgt.charAt(0) === '#') return tgt.slice(1);

    return trigger.getAttribute('aria-controls') || '';
  }

  function setShowAllUI(trigger, expanded) {
    trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    trigger.classList.toggle('collapsed', !expanded);
  }

  function toggleShowAll(trigger) {
    var key = getShowAllKey(trigger);
    if (!key) return;

    var el = document.getElementById(key);
    if (!el) return;

    var isOpen = trigger.getAttribute('aria-expanded') === 'true';

    if (hasBootstrapCollapse) {
      var inst = window.bootstrap.Collapse.getOrCreateInstance(el, { toggle: false });
      if (isOpen) inst.hide(); else inst.show();
      setShowAllUI(trigger, !isOpen);
    } else {
      var open = el.classList.toggle('show');
      setShowAllUI(trigger, open);
    }
  }

  // -------------------------
  // Search under title
  // -------------------------
  function getBodyEl(widget) {
    var label = widget.querySelector('label[aria-controls]');
    if (label) {
      var id = label.getAttribute('aria-controls');
      if (id) {
        var el = document.getElementById(id);
        if (el) return el;
      }
    }
    return widget.querySelector('.gsp-widget-inner, .gsp-block-body') || null;
  }

  function getRowText(row) {
    if (textCache && textCache.has(row)) return textCache.get(row);

    var t =
      row.querySelector('.gsp-product-option-label span') ||
      row.querySelector('label span') ||
      row.querySelector('label') ||
      row;

    var out = norm(t ? t.textContent : '');

    if (textCache) textCache.set(row, out);
    return out;
  }

  function collectRows(body) {
    // собираем "строки" только один раз
    var inputs = body.querySelectorAll('input[type="checkbox"], input[type="radio"]');
    if (!inputs.length) return [];

    var rows = [];
    var seen = typeof Set !== 'undefined' ? new Set() : null;

    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      var row =
        (inp.closest && inp.closest('li')) ||
        (inp.closest && inp.closest('.form-check')) ||
        inp.parentElement;

      if (!row) continue;

      if (seen) {
        if (seen.has(row)) continue;
        seen.add(row);
      } else {
        // very old fallback
        var dup = false;
        for (var j = 0; j < rows.length; j++) if (rows[j] === row) { dup = true; break; }
        if (dup) continue;
      }
      rows.push(row);
    }
    return rows;
  }

  function ensureSearch(widget) {
    // only metafield widgets
    if (!widget || !widget.matches || !widget.matches(META_WIDGET_SEL)) return;

    // per-widget toggle (disabled)
    if (widget.getAttribute('data-gsp-metafield-search') === '0') {
      // if search was previously injected, remove it
      var existing = widget.querySelector('.' + WRAP_CLASS);
      if (existing) existing.remove();
      return;
    }

    // already exists
    if (widget.querySelector('.' + INPUT_CLASS)) return;

    var titleLabel = widget.querySelector('label.gsp-widget-title-toggle');
    if (!titleLabel) return;

    var body = getBodyEl(widget);
    if (!body) return;

    // If there is no "Show more/less" for this widget,
    // it means options <= limit -> search is not needed
    var filterList =
      widget.querySelector('gsp-widget-filter-list') ||
      widget.querySelector('.gsp-widget-filter-list');

    var showAllHeading = filterList
      ? filterList.querySelector('.gsp-filter-showall-heading')
      : null;

    if (!showAllHeading) return;

    var rows = rowsCache && rowsCache.get(widget);
    if (rows && rows.length && rows[0] && !rows[0].isConnected) rows = null;

    if (!rows) {
      rows = collectRows(body);
      if (!rows.length) return;
      if (rowsCache) rowsCache.set(widget, rows);
    }

    // insert wrap right under title label
    var wrap = document.createElement('div');
    wrap.className = WRAP_CLASS;

    var input = document.createElement('input');
    input.type = 'search';
    input.className = INPUT_CLASS;
    var ph = widget.getAttribute('data-gsp-metafield-search-placeholder');
    input.placeholder = ph ? ph : 'Search...';
    input.autocomplete = 'off';
    input.spellcheck = false;

    wrap.appendChild(input);
    titleLabel.insertAdjacentElement('afterend', wrap);

    function updateShowAllVisibility() {
      var q = norm(input.value);
      showAllHeading.style.display = q ? 'none' : '';
    }

    function applyFilter() {
      var q = norm(input.value);

      // hide show more/less while searching
      updateShowAllVisibility();

      // multi-word prefix search (AND across query words)
      var queries = q ? q.split(/\s+/) : null;

      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var txt = getRowText(row);

        var show = true;

        if (queries && queries.length) {
          // normalize separators in option label into spaces, then split into words
          var words = txt.replace(/[\/\-]+/g, ' ').split(/\s+/);

          show = queries.every(function (qWord) {
            if (!qWord) return true;
            return words.some(function (word) {
              return word.indexOf(qWord) === 0;
            });
          });
        }

        row.style.display = show ? '' : 'none';
      }
    }

    input.addEventListener('input', applyFilter);

    // reset search when widget collapses
    var toggleInput = widget.querySelector('.gsp-widget-toggle-input');
    if (toggleInput) {
      toggleInput.addEventListener('change', function () {
        if (!toggleInput.checked) {
          input.value = '';
          applyFilter();
        }
      }, { passive: true });
    }

    // initial state (in case value is prefilled by browser)
    updateShowAllVisibility();
  }

  // -------------------------
  // Hide empty metafield widgets (fast)
  // -------------------------
  function widgetHasAnyOption(widget) {
    var body = getBodyEl(widget) || widget;

    // один быстрый запрос вместо querySelectorAll
    return !!body.querySelector(
      'input[type="checkbox"], input[type="radio"], li, label'
    );
  }

  function applyHideEmpty(sidebar) {
    var widgets = sidebar.querySelectorAll(META_WIDGET_SEL);
    for (var i = 0; i < widgets.length; i++) {
      var w = widgets[i];
      w.style.display = widgetHasAnyOption(w) ? '' : 'none';
    }
  }

  // -------------------------
  // Init / re-init
  // -------------------------
  function initAll(sidebar) {
    if (!sidebar) return;

    var widgets = sidebar.querySelectorAll(META_WIDGET_SEL);
    for (var i = 0; i < widgets.length; i++) ensureSearch(widgets[i]);

    applyHideEmpty(sidebar);

    // anti-jump marker (CSS снимает visibility:hidden)
    document.documentElement.classList.add('gsp-filters-ready');
  }

  function scheduleInit(sidebar) {
    if (scheduled) return;
    scheduled = true;
    raf(function () {
      scheduled = false;
      initAll(sidebar);
    });
  }

  // -------------------------
  // Events
  // -------------------------
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest(SHOWALL_SEL) : null;
    if (!t) return;

    if (t.getAttribute('href') === '#') e.preventDefault();
    
    if (!hasBootstrapCollapse) {
      toggleShowAll(t);
    }
  });

  // -------------------------
  // Boot
  // -------------------------
  function boot() {
    var sidebars = getSidebars();
    if (!sidebars.length) return;

    sidebars.forEach(function (sidebar) {
      initAll(sidebar);
    });

    // Observe only sidebar (faster)
    try {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) {
            scheduleInit(sidebar);
            return;
          }
        }
      });
      mo.observe(sidebar, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();